const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_solmis-reunion/artifacts/488ns2m8_LOGO%20PRIMAIRE.png";

export default function Logo({
  withTagline = false,
  variant = "dark", // "dark" = sur fond clair · "light" = sur fond foncé (inversion via filter si besoin)
  size = 88,
  className = "",
}) {
  const subColor =
    variant === "light" ? "rgba(242,238,231,0.65)" : "rgba(47,45,42,0.55)";

  return (
    <span className={`inline-flex items-center gap-5 ${className}`}>
      <img
        src={LOGO_URL}
        alt="Solmis Habitat — Études de sol et dossiers de permis"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="block object-contain shrink-0"
      />
      {withTagline && (
        <span
          className="hidden sm:flex flex-col leading-none border-l border-current/20 pl-5"
          style={{ borderColor: subColor }}
        >
          <span
            className="text-[9px] uppercase tracking-[0.26em] font-light"
            style={{ color: subColor, fontFamily: "Manrope, sans-serif" }}
          >
            La Réunion
          </span>
          <span
            className="mt-2 text-[9px] uppercase tracking-[0.24em] font-light"
            style={{ color: subColor, fontFamily: "Manrope, sans-serif" }}
          >
            Études de sol · Permis
          </span>
        </span>
      )}
    </span>
  );
}
